<template>
  <router-view></router-view>
  <footer class="footer mt-auto py-3">
    <div class="container">
      <div class="row align-items-center d-flex justify-content-center">
        <div class="col-8">
          <div class="row">
            <div class="col text-center">
              <a href="https://www.dynataprivacy.com/terms/" target="_blank">
                {{ $t.terms || "Terms & Conditions" }}
              </a>
              |
              <a href="https://www.dynataprivacy.com/privacy/" target="_blank">
                {{ $t.privacy || "Privacy Policy" }}
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </footer>
</template>

<script setup>
import { inject, computed, watch } from "vue";

let $t = inject("$t") || {};
const locale = inject("locale");
let language = computed(() => locale?.value?.split('_')?.[0]);

const rtlLangs = ["ar", "he"];

watch(language, (newLang) => {
  document.documentElement.setAttribute("lang", newLang);
  document.documentElement.setAttribute("dir", rtlLangs.includes(newLang) ? "rtl" : "ltr");
}, {
  immediate: true,
});

</script>

<style lang="scss">
@import "styles/base";

.footer {
  margin-bottom: 170px;
}
#main {
  margin-top: 50px;
  text-align: center;
  font-family: Helvetica,serif;

  .headertext {
    color: #555555;
    font-weight: bold;
    font-size: 28px;
    letter-spacing: 1px;
  }

  #content {
    font-size: 24px;
    margin-top: 20px;

    p {
      margin: 15px 0 5px;
    }

    p:not(:first-child) {
      margin: 10px 0;
    }
  }

  #btn {
    background: #40b3ff;
    display: inline-block;
    font-size: 18px;
    font-weight: bold;
    margin-top: 20px;
    padding: 15px;
    border-radius: 8px;
    color: #fff;
    a {
      color: #fff;
      text-decoration: none;
    }
  }
}
</style>
